module.exports = __webpack_public_path__ + "static/media/general-welcome-animation.fff08abe.svg";